// @ts-nocheck
import getIconDataSrc from "@toolkit/Framework/Common/Utilities/getIconDataSrc";
import * as React from "react";

const Checkmark: React.FC = () => {
    /* Store Custom Code - Start */
    return (
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <path
                fill="currentColor"
                d="M18.41 4.41a2.25 2.25 0 0 1 3.181 3.18l-11 11a2.25 2.25 0 0 1-3.182 0l-5-5a2.25 2.25 0 1 1 3.182-3.18L9 13.817z"
            />
        </svg>
    );
    /* Store Custom Code - End */
};

export const CheckmarkDataSrc = getIconDataSrc(Checkmark);

export default React.memo(Checkmark);
